import createSelectorDefinition from './create.js'
import createIsOnSelectorDefinition from './create-is-on.js'
import createUnavailableReasonSelectorDefinition from './create-unavailable-reason.js'

export default [
  createSelectorDefinition,
  createIsOnSelectorDefinition,
  createUnavailableReasonSelectorDefinition,
]
